export default "__VITE_ASSET__30565f45__"